import { render, staticRenderFns } from "./DailyFerryDetail.vue?vue&type=template&id=b3de95f8"
import script from "../../controllers/daily_ferry/daily-ferry-detail.js?vue&type=script&lang=js&external"
export * from "../../controllers/daily_ferry/daily-ferry-detail.js?vue&type=script&lang=js&external"
import style0 from "./DailyFerryDetail.vue?vue&type=style&index=0&id=b3de95f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports